import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import { getQuery } from '@src/utils/utils';

/**
 * 定义 Footer 组件
 */
class BrandList extends React.PureComponent {
    static propTypes = {
        brandData: PropTypes.array,
        brandDataList: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { brandData, brandDataList } = this.props;
        const brandId = getQuery(location.href, 'brandId');
        const autoLogo = brandData?.[brandId]?.pic || '';
        const autoTitle = brandData?.[brandId]?.name || '';

        // 个数不满足 5 的倍数时，补充空白, 用于占位 最终是5的倍数 满足5的倍数不处理
        const len = brandDataList.length % 5;

        if (len !== 0) {
            for (let i = 0; i < 5 - len; i++) {
                brandDataList.push(i);
            }
        }

        return (
            <div className={styles.brandList}>
                <div className={styles.brandListName}>
                    {autoLogo && <img src={autoLogo} className={styles.brandListLogo} />}
                    {autoTitle || ''}
                </div>
                <div className={styles.brandListImageList}>
                    {brandDataList.map((item, index) => {
                        return (
                            <a href={item?.url} target="_blank" key={index} className={styles.brandListPic}>
                                {item?.thumbnails?.image?.[0]?.url && (
                                    <img
                                        className={styles.brandListPicTag}
                                        src={formatImage(item.thumbnails.image[0].url || '', 400, 268)}
                                    />
                                )}
                                <div className={styles.brandListText}>{item?.title || ''}</div>
                            </a>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default errorBoundary(BrandList);
